import React from 'react';
import Modal from './Modal';
import allLangs from '../langs';
import find from 'lodash.find';
import { connect } from 'react-redux';

import {
  select,
  moveUp,
  moveDown,
  remove,
  save,
  setEnableFlag,
} from '../actions/language-element-actions';

import styles from '../../../../stylesheet/css/header-builder/language-element-options.css';

export const LanguageElementOptions = React.createClass({
  getInitialState() {
    return {
      languageInfoModalIsOpen: false,
      temporaryLanguageInfo: {}
    };
  },

  handleRemove(lang, e) {
    e.stopPropagation();
    this.props.onRemove(lang);
  },

  getRemindedLangs() {
    const { options = {} } = this.props,
          { langs = [] } = options;

    return allLangs.filter(l => !find(langs, lg => lg.name === l.value));
  },

  closeLanguageModal() {
    this.setState({
      ...this.state,
      languageInfoModalIsOpen: false
    });
  },

  handleAdd() {
    const remindedLangs = this.getRemindedLangs();

    if (remindedLangs.length === 0) {
      alert('You already added all available languages.');
      return;
    }

    this.setState({
      ...this.state,
      languageInfoModalIsOpen: true,
      temporaryLanguageInfo: {
        mode: 'add',
        name: remindedLangs[0].value
      }
    });
  },

  handleEdit(lang, e) {
    const { options = {} } = this.props,
          { langs = [] } = options;

    e.stopPropagation();

    this.setState({
      ...this.state,
      languageInfoModalIsOpen: true,
      temporaryLanguageInfo: {
        ...find(langs, l => l.name === lang),
        mode: 'edit',
        titleError: ''
      }
    });
  },

  handleModalCancelClick() {
    this.closeLanguageModal();
  },

  handleTemporaryLanguageInfoChange(key, value) {
    this.setState({
      ...this.state,
      temporaryLanguageInfo: {
        ...this.state.temporaryLanguageInfo,
        [key]: value
      }
    });
  },

  handleModalSaveClick() {
    const { title = '', url = '' } = this.state.temporaryLanguageInfo,
          titleError = !title.trim() ? 'Title is required!' : '';

    if (titleError) {
      this.setState({
        ...this.state,
        temporaryLanguageInfo: {
          ...this.state.temporaryLanguageInfo,
          titleError
        }
      });

      return;
    }

    this.props.onSave(this.state.temporaryLanguageInfo);
    this.closeLanguageModal();
  },

  renderRemindedLanguages() {
    if (this.state.temporaryLanguageInfo.mode === 'edit') {
      return null;
    }

    return (
      <div>
        <header>Language</header>
        <select
          value={this.state.temporaryLanguageInfo.name}
          onChange={e => this.handleTemporaryLanguageInfoChange('name', e.target.value)}
        >
          {this.getRemindedLangs().map(l => <option key={l.value} value={l.value}>{l.text}</option>)}
        </select>
        <br />
        <br />
      </div>
    );
  },

  renderLanguageList() {
    const {
      onSelect,
      onMoveUp,
      onMoveDown,
      onRemove,
      options = {}
    } = this.props;

    const { langs = [], selectedLanguage } = options;
    let langList;

    if (langs.length === 0) {
      langList = (
        <span className={styles.empty}>
          Add languages using <span className="fa fa-plus"></span> button
        </span>
      );
    } else {
      langList = (
        <div className={styles.languageList}>
          {
            langs.map(l => (
              <div
                key={l.name}
                className={styles.languageItem + (selectedLanguage === l.name ? ' ' + styles.selected : '')}
                onClick={onSelect.bind(null, l.name)}
              >
                <span
                  className={`${styles.languageItemEdit} fa fa-pencil-square-o`}
                  onClick={this.handleEdit.bind(null, l.name)}
                >
                </span>
                <span className={styles.languageItemText}>{l.title}</span>
                <span
                  className={`${styles.languageItemRemove} fa fa-remove`}
                  onClick={this.handleRemove.bind(null, l.name)}
                >
                </span>
              </div>
            ))
          }
        </div>
      );
    }

    return (
      <div>
        {langList}
        <div className={styles.languageListFooter}>
          <span className={`${styles.add} fa fa-plus fa-lg`} onClick={this.handleAdd}></span>
          <span className={`${styles.moveDown} fa fa-chevron-down fa-lg`} onClick={onMoveDown}></span>
          <span className={`${styles.moveUp} fa fa-chevron-up fa-lg`} onClick={onMoveUp}></span>
        </div>
      </div>
    );
  },

  renderModal() {
    return (
      <Modal
        isOpen={this.state.languageInfoModalIsOpen}
        contentLabel='Language Element Options'
        header={
          this.state.temporaryLanguageInfo.mode === 'edit'
            ? `Edit ${find(allLangs, l => l.value === this.state.temporaryLanguageInfo.name).text} language`
            : 'Add new language'
        }
        footer={[
          {
            text: this.state.temporaryLanguageInfo.mode === 'edit' ? 'Save' : 'Add',
            onClick: this.handleModalSaveClick
          },
          { text: 'Cancel', onClick: this.handleModalCancelClick }
        ]}
        width='400px'
      >
        {this.renderRemindedLanguages()}
        <header>Title (required)</header>
        <input
          type="text"
          autoFocus="true"
          style={this.state.temporaryLanguageInfo.titleError ? { border: '2px solid red' } : {}}
          value={this.state.temporaryLanguageInfo.title || ''}
          onChange={e => this.handleTemporaryLanguageInfoChange('title', e.target.value)}
        />
        <br />
        <br />
        <header>URL</header>
        <input
          type="text"
          value={this.state.temporaryLanguageInfo.url || ''}
          onChange={e => this.handleTemporaryLanguageInfoChange('url', e.target.value)}
        />
      </Modal>
    );
  },

  render() {
    const {
      onEnableFlag,
      options = {},
    } = this.props;

    const { enableFlag } = options;

    return (
      <div>
        <header>Languages:</header>
        {this.renderLanguageList()}

        <header>Enable Flag:</header>
        <select
          value={enableFlag ? 'yes' : 'no'}
          onChange={e => onEnableFlag(e.target.value === 'yes')}>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>

        {this.renderModal()}
      </div>
    );
  }
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id, options } = ownProps,
        selectedLanguage = options.selectedLanguage;

  return {
    onSelect(lang) {
      dispatch(select({ device, id, lang }));
    },

    onMoveUp() {
      dispatch(moveUp({ device, id, selectedLanguage }));
    },

    onMoveDown() {
      dispatch(moveDown({ device, id, selectedLanguage }));
    },

    onRemove(lang) {
      dispatch(remove({ device, id, lang }));
    },

    onSave(langInfo) {
      dispatch(save({ device, id, langInfo }));
    },

    onEnableFlag(enableFlag) {
      dispatch(setEnableFlag({ device, id, enableFlag }));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(LanguageElementOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/LanguageElementOptions.js